var map = {
	"./four.svg": 16654,
	"./klarna-logo-Bottom.svg": 7725,
	"./klarna-logo-Top-mobile.svg": 48064,
	"./klarna-logo-Top.svg": 58597,
	"./one.svg": 42118,
	"./three.svg": 15566,
	"./two.svg": 64528
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37499;